import { findEntry } from "../routes/switchboard";
import type { SwitchEntry } from "../routes/switchboard";

/** Which Dashboard the switchboard serves: the new Home ("next") or today's Dashboard ("legacy"). */
export type DashboardMode = SwitchEntry["mode"];
export const dashboardMode = (board?: SwitchEntry[]): DashboardMode => findEntry("/dashboard", board)?.entry.mode ?? "legacy";
